import React from 'react';
import {IconButton, Tooltip, Typography} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import {PlanRow} from '../CreateBuilder/BuilderSourceDestination/PlanRow';
import {PlanAccordionShell} from '../CreateBuilder/BuilderSourceDestination/PlanAccordionShell';
import {PlanSelector} from '../CreateBuilder/BuilderSourceDestination/PlanSelector';
import {PlanValidationIcon} from '../CreateBuilder/BuilderSourceDestination/PlanValidationIcon';
import {usePlanValidationLevel} from '../CreateBuilder/BuilderSourceDestination/usePlanValidationLevel';
import {BuilderNewSubPlanDetails} from './BuilderNewSubPlanDetails';
import {PlanProviderSelectOption} from '../../../hooks/usePlanNamesProviders';
import {useAutoForm} from '../../../components/AutoForm/useAutoForm';
import {builderFieldsType} from '../CreateBuilder/builderFields';
import {isBondPlan} from './bondSetUpNew';

interface SetUpNewSubplanProps {
  index: number;
  subplanId: string | null; // e.g. 'subplan0', 'subplan1'
  formikKeyPrefix: string; // e.g. 'setUpNew.subplan0'
  handleChange: () => void;
  productProviders: PlanProviderSelectOption[] | undefined;
  onRemove?: () => void;
}

export const SetUpNewSubplan: React.FC<SetUpNewSubplanProps> = ({
  index,
  subplanId,
  formikKeyPrefix,
  handleChange,
  productProviders,
  onRemove,
}) => {
  const {bgClass} = usePlanValidationLevel(formikKeyPrefix);
  const {values} = useAutoForm<builderFieldsType>();
  // A bond has exactly one subplan, always the Saltus GIA Gross.
  const title = isBondPlan(values.mainPlanType) ? 'Subplan - GIA Gross' : 'Subplan';

  return (
    <PlanRow id={subplanId || `${index}`} reccId={null} isSelected isSubplan>
      <PlanAccordionShell
        expanded
        isSelected
        isSoleParent={false}
        validationLevel={bgClass}
        summaryChildren={
          <>
            <PlanSelector
              mode="multiple"
              id={index.toString()}
              isSelected
              fixed={!!subplanId}
              handleChange={subplanId ? undefined : handleChange}
            />
            <Typography>{title}</Typography>
          </>
        }
        summaryTrailing={
          <>
            <PlanValidationIcon formikKeyPrefix={formikKeyPrefix} />
            <Tooltip
              title={
                onRemove
                  ? ''
                  : 'Only unsaved subplans can be deleted. To remove this subplan, delete the recommendation and re-create it.'
              }
              disableHoverListener={!!onRemove}
            >
              <span>
                <IconButton
                  aria-label="Remove subplan"
                  onClick={onRemove}
                  disabled={!onRemove}
                  color="error"
                  sx={{opacity: onRemove ? 1 : 0.4}}
                >
                  <DeleteIcon fontSize="medium" />
                </IconButton>
              </span>
            </Tooltip>
          </>
        }
      >
        <BuilderNewSubPlanDetails
          formikKeyPrefix={formikKeyPrefix}
          productProviders={productProviders}
        />
      </PlanAccordionShell>
    </PlanRow>
  );
};
